import { SwapRoutesParams } from "../../types";
import { useSwapRoutesDomain } from "../domain/swap-routes";

// Identity adapter: mints/flags need no rescaling and minInputAmount (u64) stays bigint for consumers.
export function useSwapRoutes(params: SwapRoutesParams & { skip?: boolean }) {
    return useSwapRoutesDomain(params);
}
